export const CREATE_CLIENTWORK_REQUEST = "CREATE_CLIENTWORK_REQUEST";
export const CREATE_CLIENTWORK_SUCCESS = "CREATE_CLIENTWORK_SUCCESS";
export const CREATE_CLIENTWORK_FAILURE = "CREATE_CLIENTWORK_FAILURE";

export const GET_CLIENTWORK_REQUEST = "GET_CLIENTWORK_REQUEST";
export const GET_CLIENTWORK_SUCCESS = "GET_CLIENTWORK_SUCCESS";
export const GET_CLIENTWORK_FAILURE = "GET_CLIENTWORK_FAILURE";

